import axios from "axios";
import { defineStore } from "pinia";
import { ref } from "vue";
import { AuditNoticeOption } from "@/audit.types";
import { handleError } from "./storeHelper";

export const useAuditNoticeStore = defineStore("auditNoticeStore", () => {
    const loading = ref<boolean>(false);
    const items = ref<AuditNoticeOption[]>();
    const apiUrl = 'api/v1/audit/notice';


    const list = async (auditId: number) => {

        try {
            loading.value = true;
            const response = await axios.get<AuditNoticeOption[]>(`${apiUrl}/${auditId}`);
            items.value = response.data;
        }
        catch (error) {
            handleError(error);
            throw error;
        }
        finally {
            loading.value = false;
        }
    }


    return {
        loading,
        items,
        list
    };
})